// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "integration_gitlab-" + chunkId + ".js?v=" + {"vendors-node_modules_vue-material-design-icons_OpenInNew_vue-node_modules_nextcloud_moment_di-25d36e":"b99c7bf1e65e374e9c5e","reference-lazy":"ace93976ab3f5022b276","vendors-node_modules_rehype-highlight_index_js":"d515295be10f6163f8c8"}[chunkId] + "";
};